import React, { useState } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import api from "../../api/axios";

const VendorSponsorshipCard = ({
  sponsorshipStatus = "NONE", // ✅ NEW
  vendorId,
  compact = false,
  onApplied
}) => {
  const [loading, setLoading] = useState(false);

  const handleApply = async () => {
    try {
      setLoading(true);
      await api.post(`/vendor/${vendorId}/apply-sponsorship`);
      onApplied?.();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
  const { data } = await api.post(
    `/vendor/${vendorId}/create-sponsorship-order`,
    { plan: "30_DAYS" }
  );

  const options = {
    key: "RAZORPAY_KEY",
    amount: data.amount * 100,
    order_id: data.orderId,

    handler: async function (response) {
      await api.post(
        `/vendor/${vendorId}/verify-sponsorship-payment`,
        {
          paymentId: response.razorpay_payment_id,
          plan: "30_DAYS"
        }
      );
      onApplied?.();
    }
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};
  /* ================= UI ================= */

  // ✅ ACTIVE → Sponsored badge
  if (sponsorshipStatus === "ACTIVE") {
    return (
      <Chip
        icon={<WorkspacePremiumIcon />}
        label="Sponsored Seller"
        sx={{
          bgcolor: "#fff4e5",
          color: "#b26a00",
          fontWeight: 600,
          fontSize: 12
        }}
      />
    );
  }

  // ✅ PENDING → Under Review
  if (sponsorshipStatus === "PENDING") {
    return (
      <Chip
        icon={<HourglassEmptyIcon />}
        label="Under Review"
        sx={{
          bgcolor: "#e3f2fd",
          color: "#1565c0",
          fontWeight: 600
        }}
      />
    );
  }

  if(sponsorshipStatus==="PENDING_PAYMENT") {
    return (
  <Button onClick={handlePayment}>
    Complete Payment
  </Button>
)}

if(sponsorshipStatus==="EXPIRED") {
    return (
  <Button onClick={handlePayment}>
        Renew Sponsorship
  </Button>
)}

  // ✅ NONE → Show Apply UI
  return (
    <Box
      sx={{
        p: compact ? 2 : 3,
        borderRadius: 3,
        border: "1px solid #f0c14b",
        bgcolor: "#fffdf7",
        display: "flex",
        flexDirection: compact ? "row" : "column",
        alignItems: compact ? "center" : "flex-start",
        justifyContent: "space-between",
        gap: 2
      }}
    >
      {/* LEFT */}
      <Box sx={{ flex: 1 }}>
        <Typography fontWeight={700}>
          Become a Sponsored Seller 🚀
        </Typography>

        {!compact && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.5 }}
          >
            Increase visibility, boost sales, and earn customer trust with a
            sponsored badge.
          </Typography>
        )}
      </Box>

      {/* RIGHT */}
      <Button
        variant="contained"
        size="small"
        onClick={handleApply}
        disabled={loading}
        sx={{
          bgcolor: "#ffd814",
          color: "#000",
          fontWeight: 600,
          "&:hover": { bgcolor: "#f7ca00" }
        }}
      >
        {loading ? "Applying..." : "Apply"}
      </Button>
    </Box>
  );
};

export default VendorSponsorshipCard;